export enum CustomHeader {
	ApiFeatures = 'x-pletly-features',
}

export enum ApiFeatureHeaderValue {
	NewMediaUrl = 'new-media-url',
}
